<section id="content_body" style="overflow: scroll !important">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="row">
                        <div class="col-md-6 col-sm-12" *ngFor="let daily of stats.daily; let i = index">
                            <div class="card">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="stats_name">{{daily?.name}}</div>
                                            <div class="digits"><span *ngIf="i === 1">N</span>{{daily?.number | number}}</div>
                                        </div>
                                    <div class="col-md-4">
                                        <img style="width: 100%" src="../../../assets/small chart.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col-md-6 col-sm-12">
                    <div class="row">
                        <div class="col-md-6 col-sm-3" *ngFor="let total of stats.total; let i = index">
                            <div class="card">
                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="stats_name">{{total?.name}}</div>
                                            <div class="digits"><span *ngIf="i === 1">N</span>{{total?.number | number}}</div>
                                        </div>
                                    <div class="col-md-4">
                                        <img style="width: 100%" src="../../../assets/small chart.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row bottom_row">
                <div class="col-md-7 bg">
                    <div>
                        <div style="margin: 20px">
                            <div class="date">Today, 31st December, 2021</div>

                            <div class="pull-right date_sub_cont">
                                <button style="margin-right: 40px" class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    1 Jan - 1 Jun
                                    <svg style="margin-left: 30px" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </button>
                                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                   <
                                </button> &nbsp;
                                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                   >
                                </button>
                            </div>
                        </div>
                        <canvas id="myChart">
                        </canvas>
                        <div class="bg2"></div> 
                    </div>
                </div>
                <div class="col-md-5 bg no-padding no-bg">
                    <div class="col-md-12 no-padding">
                        <div class="other_cards">
                            <div class="other_cards_title">Orders</div>
                            <div class="progress" style="height: 4px; margin-top: 11px">
                                <div class="progress-bar bg-success" role="progressbar" style="width: 80%" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                <div class="progress-bar bg-warning" role="progressbar" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <!-- <div> -->
                                <div><span class="key">Pending Orders:</span> &nbsp;<span class="value1">20</span></div>
                                <div><span class="key">Reconciled Orders:</span> &nbsp;<span class="value2">80</span></div>
                                <div><span class="key">Total Orders:</span> &nbsp;<span class="value3">100</span></div>
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="col-md-12 no-padding">
                            <div class="other_cards" style="margin-top: 5px !important">
                                <div class="other_cards_title">Payments</div>
                                <div class="progress" style="height: 4px; margin-top: 11px">
                                    <div class="progress-bar bg-success" role="progressbar" style="width: 80%" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                                    <div class="progress-bar bg-warning" role="progressbar" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <!-- <div> -->
                                    <div><span class="key">Pending Payments:</span> &nbsp;<span class="value1">20</span></div>
                                    <div><span class="key">Reconciled Payments:</span> &nbsp;<span class="value2">80</span></div>
                                    <div><span class="key">Total Payments:</span> &nbsp;<span class="value3">100</span></div>
                                <!-- </div> -->
                            </div>
                        </div>
                </div>
            </div>
            <div class="table-cont">
                <div class="table-details">
                    <div class="table-title">Payments</div>
                    <div>
                        <div class="pull-left inst">Showing <a>&nbsp; 20 v &nbsp;</a> out of {{items?.length}} Payments</div>
                            
                        <!-- <div style="display:inline-block; width:320px; margin-bottom: 10px;">
                            <svg xmlns="http://www.w3.org/2000/svg" style="color: #787878; display: inline-block" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>  
                            <input type="text" style="width: 260px; display: inline-block" class="form-control input" placeholder="Username" aria-label="Username" aria-describedby="addon-wrapping">
                        </div> -->

                        <div class="pull-right drop-cont">
                                <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                          All
                                          <svg style="margin-left: 30px" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                        </svg>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                          <a class="dropdown-item" href="#">Action</a>
                                          <a class="dropdown-item" href="#">Another action</a>
                                          <a class="dropdown-item" href="#">Something else here</a>
                                        </div>
                                      </div>
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                        <table class="table table-list-search">
                                <thead>
                                    <tr>
                                        <td *ngFor="let head of headers">{{head}}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of items">
                                        <td style="color: #414042, 100% !important"><img src="../../../assets/man.png" style="margin-right: 20px" class="avatar">{{item?.type}}</td>
                                        <td>{{item?.price}}</td>
                                        <td>{{item?.ref}}</td>
                                        <td>{{item?.time}}</td>
                                        <td> 
                                            <button type="button" class="btn" [ngClass]="{'warning-btn': item.status === 'pending', 'success-btn':item.status === 'reconciled', 'grey-btn':item.status === 'unreconciled' }">
                                                <span class="btn-text">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="currentColor" class="bi bi-circle-fill" viewBox="0 0 16 16">
                                                        <circle cx="8" cy="8" r="8" style="margin-left: 5px !important; margin-right: auto !important"/>
                                                    </svg>
                                                    {{item?.status}}
                                                </span>
                                            </button>

                                            <svg style="margin-left: 30px" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                            </svg>
                                        </td>
                                    </tr>
                                </tbody>
                            </table> 
                </div>
                <div>
                    <div class="pull-left pagination_text">Showing 1 to 10 of 500 entries</div>

                        <div class="page-nation pull-right">
                                <ul class="pagination pagination-large">
                                <li class="disabled"><span>Prev</span></li>
                                <li class="active"><span>1</span></li>
                                <li><a href="#">2</a></li>
                                <li><a rel="next" href="#">Next</a></li>
                             </ul>
                    </div>
                </div>
            </div>
</section>